// These functions designed to be call incrementally,
// so it can run as frequent as player events triggers.
//
// We'll don't care about 'duration' field from the fragments
// since they're floating numbers. Adding them may made some difference,
// from just re-calculate from end-start time again.

const defaultState = {
  nextFragmentIndex: 0,
  startProgramDateTime: 0,
  endProgramDateTime: 0,
  videoDuration: 0,
  timelineDuration: 0,
  contentTimelines: [],
  blackholeTimelines: [],
};

function isFragmentContinued(fragment, latestEndProgramDateTime) {
  if (!latestEndProgramDateTime || latestEndProgramDateTime <= 0) {
    return false;
  }

  return latestEndProgramDateTime === fragment.programDateTime
    || Math.abs(latestEndProgramDateTime - fragment.programDateTime) < 1000;
}

function newStateWithContinuedTimelines(previousState, fragment) {
  const previousLastContentTimeline = previousState.contentTimelines[
    previousState.contentTimelines.length - 1
  ];

  const fragmentEndProgramDateTime = Math.floor(fragment.endProgramDateTime);
  const newTimelineDuration = fragmentEndProgramDateTime
    - previousLastContentTimeline.startProgramDateTime;

  const nextLastContentTimeline = {
    ...previousLastContentTimeline,
    duration: newTimelineDuration,
    endProgramDateTime: fragmentEndProgramDateTime,
    endVideoTime: previousLastContentTimeline.startVideoTime + newTimelineDuration,
    endTimelineTime: previousLastContentTimeline.startTimelineTime + newTimelineDuration,
  };

  return {
    nextFragmentIndex: previousState.nextFragmentIndex + 1,
    startProgramDateTime: previousState.startProgramDateTime || fragment.programDateTime,
    endProgramDateTime: Math.floor(fragment.endProgramDateTime),
    videoDuration: nextLastContentTimeline.endVideoTime,
    timelineDuration: nextLastContentTimeline.endTimelineTime,
    contentTimelines: [
      ...previousState.contentTimelines.slice(0, -1),
      nextLastContentTimeline,
    ],
    blackholeTimelines: previousState.blackholeTimelines,
  };
}

function newStateWithNewTimelines(previousState, fragment) {
  const fragmentDuration = Math.floor(fragment.endProgramDateTime - fragment.programDateTime);

  let previousLastContentTimeline = null;
  if (previousState.contentTimelines.length > 0) {
    previousLastContentTimeline = previousState.contentTimelines[
      previousState.contentTimelines.length - 1
    ];
  }

  let startContentTimelineTime = 0;
  if (previousState.startProgramDateTime > 0) {
    startContentTimelineTime = fragment.programDateTime - previousState.startProgramDateTime;
  }

  const newContentTimeline = {
    duration: fragmentDuration,
    startProgramDateTime: fragment.programDateTime,
    endProgramDateTime: Math.floor(fragment.endProgramDateTime),
    startTimelineTime: startContentTimelineTime,
    endTimelineTime: startContentTimelineTime + fragmentDuration,
    startVideoTime: previousLastContentTimeline ?
      previousLastContentTimeline.endVideoTime
      : 0,
    endVideoTime: previousLastContentTimeline ?
      previousLastContentTimeline.endVideoTime + fragmentDuration
      : fragmentDuration,
  };
  const newBlackholeTimeline = previousLastContentTimeline ?
    {
      duration: newContentTimeline.startTimelineTime - previousLastContentTimeline.endTimelineTime,
      startProgramDateTime: previousLastContentTimeline.endProgramDateTime,
      endProgramDateTime: fragment.startProgramDateTime,
      startTimelineTime: previousLastContentTimeline.endTimelineTime,
      endTimelineTime: newContentTimeline.startTimelineTime,
    } : null;

  return {
    nextFragmentIndex: previousState.nextFragmentIndex + 1,
    startProgramDateTime: previousState.startProgramDateTime > 0 ?
      previousState.startProgramDateTime
      : fragment.programDateTime,
    endProgramDateTime: Math.floor(fragment.endProgramDateTime),
    videoDuration: newContentTimeline.endVideoTime,
    timelineDuration: newContentTimeline.endTimelineTime,
    contentTimelines: [
      ...previousState.contentTimelines,
      newContentTimeline,
    ],
    blackholeTimelines: newBlackholeTimeline ? [
      ...previousState.blackholeTimelines,
      newBlackholeTimeline,
    ] : previousState.blackholeTimelines,
  };
}

function getStreamTimelines(fragments, state = defaultState) {
  return fragments.slice(state.nextFragmentIndex)
    .reduce((previousState, fragment) => (
      isFragmentContinued(fragment, previousState.endProgramDateTime) ?
        newStateWithContinuedTimelines(previousState, fragment)
        : newStateWithNewTimelines(previousState, fragment)
    ), state);
}

export default getStreamTimelines;
